module.exports = __webpack_public_path__ + "img/5.1b692335.png";